import { useFormik } from 'formik'
import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Api from '../Api/Api'
import * as yup from 'yup'
import { ToastContainer, toast } from 'react-toastify';

function Forgot() {
    const [loginButtonLoader,setLoginButtonLoader]=useState(true)

    const navigate=useNavigate()
    const initialValues={
        email:""
    }

    const validationSchema=yup.object({
       email:yup.string().required("Email is required").email("Email is invalid")
    })

    const submit= async(values)=>{
        setLoginButtonLoader(false)
        console.log("submit",values)
        // const valuesData=JSON.stringify(values)
        // const formData= new FormData()
        // formData.append('email',values.email)
        // formData.append('password',values.password)
        try {
            const response = await Api.post("/user/forgot-password",values)
            console.log("response---->Register",response.data)
            // localStorage.setItem("Quizetoken",response.data.result.token)
            toast(response.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            setTimeout(() => {
            navigate('/verify-otp', { state: values.email });
             }, 1000); 
            
        } catch (error) {
            console.log(error.response.data.message)
            toast(error.response.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: 'error'
            });
        }
        setLoginButtonLoader(true)
        
    }

    const formik=useFormik({
        initialValues:initialValues,
        validationSchema:validationSchema,
        onSubmit:submit
    })
  



  return (
    <>
      <ToastContainer />
    <div className="center">
        <div className="video-form container">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-12">
                    <div className="log-img">
                        <img src="/assets/images/login.png" />
                    </div>
                </div>
                <div className="col-lg-7 col-md-12">
                    <form onSubmit={formik.handleSubmit}>
                        <Link to='/login'><i className="fa-solid fa-angle-left" style={{color:'black'}}></i></Link>
                        <div className="form-header">
                            <h2>Forgot Password </h2>
                            <p>Enter your email and we'll send you a link to reset your password.</p>
                        </div>
                
                        <label for="email"><b>Registered Email Id</b></label>
                        <input type="email" name="email" value={formik.values.email} onChange={formik.handleChange}  placeholder="Enter Registered Email Id" />
                        {formik.touched.email && formik.errors.email ? <div className='text-danger' style={{float: 'right'}}>{formik.errors.email}</div> : null}
                        
                   
                        <button type="submit" className="mt-100 mt-5">
                            <a  >  {loginButtonLoader ? "Continue" : "Plase wait"} </a>
                            </button>
                        <Link to='/login' className="signup-like"><i className="fa-solid fa-angle-left" style={{color:'black'}}></i> Back to <span> Log in</span></Link>
                    </form>
                </div>
            </div>
            
         
        </div>
    </div>

    </>
  )
}

export default Forgot